import { render, staticRenderFns } from "./receiptForm.vue?vue&type=template&id=65f8530f&scoped=true&"
import script from "./receiptForm.vue?vue&type=script&lang=js&"
export * from "./receiptForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f8530f",
  null
  
)

export default component.exports